// src/lib/api/client.ts — Shared ApiClient singleton (jasit-api-kit)
import { ApiClient, TokenManager, AuthApi, UserApi, NotificationApi, NotificationsRealtimeClient } from 'jasit-api-kit';
import CONFIG from '../config';

// Migrate old token keys to new format (one-time, transparent)
if (typeof window !== 'undefined') {
    const oldAccess = localStorage.getItem('accessToken');
    const oldRefresh = localStorage.getItem('refreshToken');
    if (oldAccess && oldRefresh) {
        localStorage.setItem('nexilink_access_token', oldAccess);
        localStorage.setItem('nexilink_refresh_token', oldRefresh);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    }
}

const baseURL = `${CONFIG.API_BASE_URL}${CONFIG.API_AUTH_PORT}`;
const tokenManager = new TokenManager(undefined, 'nexilink_');
const apiClient = new ApiClient({ baseURL }, tokenManager);
const authApi = new AuthApi(apiClient);
const userApi = new UserApi(apiClient);
const notificationApi = new NotificationApi(apiClient);

export function getApiClient(): ApiClient {
    return apiClient;
}

export function getTokenManager(): TokenManager {
    return tokenManager;
}

export function getAuthApi(): AuthApi {
    return authApi;
}

export function getUserApi(): UserApi {
    return userApi;
}

export function getNotificationApi(): NotificationApi {
    return notificationApi;
}

// Real-time notification channel (WebSocket, topic "notifications"). Lazily
// created so it only connects once a consumer (the bell) asks for it. Shares the
// same baseURL + tokenManager as the REST client.
let notificationsRealtime: NotificationsRealtimeClient | null = null;
export function getNotificationsRealtime(): NotificationsRealtimeClient {
    if (!notificationsRealtime) {
        notificationsRealtime = new NotificationsRealtimeClient({ baseURL }, tokenManager);
    }
    return notificationsRealtime;
}
